import { useRentalManagerUserPropertyActivateV2WebApiHandler_activate } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import { LISTINGS_PAGE_TAGS } from '../../constants/InvalidateConstants';

export const ACTIVATE_LISTING_MUTATION_KEY = ['activateListing'];

export const useActivateListing = () => {
  return useRentalManagerUserPropertyActivateV2WebApiHandler_activate({
    mutationKey: ACTIVATE_LISTING_MUTATION_KEY,
    meta: {
      context: {
        api: 'rental-manager',
        details: 'useRentalManagerUserPropertyActivateV2WebApiHandler_activate',
      },
      invalidates: ['users-properties-activate', 'listingDetails', 'getProperties', ...LISTINGS_PAGE_TAGS],
    },
  });
};
